document.addEventListener('DOMContentLoaded', () => {
  const translateFilters = () => {
    // Traduce "0 selected"
    document.querySelectorAll('.filter-value-selected').forEach(el => {
      const txt = (el.textContent || '').trim();
      if (txt.match(/\bselected\b/i)) {
        const num = txt.match(/\d+/);
        const count = num ? num[0] : '';
        el.textContent = count
          ? `${count} seleccionados`
          : 'seleccionados';
      }
    });

    // Traduce From / To en el filtro de precio
    document.querySelectorAll('.sidebar-widget, .sidebar-body').forEach(wrap => {
      wrap.querySelectorAll('span, label').forEach(node => {
        const t = node.textContent.trim();
        if (t === 'From') node.textContent = 'Desde';
        if (t === 'To') node.textContent = 'Hasta';
      });
    });
  };

  // Ejecuta al cargar
  translateFilters();

  // Observa cambios dinámicos (filtros AJAX)
  const observer = new MutationObserver(translateFilters);
  observer.observe(document.body, { childList: true, subtree: true });
});
